import { ActionReducerMap, createFeatureSelector, createSelector } from "@ngrx/store";

import * as globalInfo from "./global-info";
import * as homesData from "./homes.data";
import * as homesUI from "./homes.ui";
import * as pharmacyData from "./pharmacies.data";
import * as pharmacyUI from "./pharmacies.ui";

export interface State {
	globalInfo: globalInfo.State;
	homesData: homesData.State;
	homesUI: homesUI.State;
	pharmacyData: pharmacyData.State;
	pharmacyUI: pharmacyUI.State;
}

// Reducer
export const reducers: ActionReducerMap<State> = {
	globalInfo: globalInfo.reducer,
	homesData: homesData.reducer,
	homesUI: homesUI.reducer,
	pharmacyData: pharmacyData.reducer,
	pharmacyUI: pharmacyUI.reducer,
};

// Selectors
const selectCoreState = createFeatureSelector<State>("core");
const homesDataSelector = createSelector(selectCoreState, (state: State) => state.homesData);
const homesUISelector = createSelector(selectCoreState, (state: State) => state.homesUI);
const pharmacyDataSelector = createSelector(selectCoreState, (state: State) => state.pharmacyData);
const pharmacyUISelector = createSelector(selectCoreState, (state: State) => state.pharmacyUI);

export const getGlobalInfo = createSelector(selectCoreState, (state: State) => state.globalInfo);

export const getHomes = createSelector(homesDataSelector, homesData.getHomes);
export const getSavingPharmacy = createSelector(pharmacyUISelector, pharmacyUI.getSavingPharmacy);
export const getPharmacies = createSelector(pharmacyDataSelector, pharmacyData.getPharmacies);

export const getHomesLoading = createSelector(homesUISelector, homesUI.getLoading);
export const getHomesUpdating = createSelector(homesUISelector, homesUI.getUpdating);
